import { render, staticRenderFns } from "./CityDetail.vue?vue&type=template&id=2ac2b3ba&scoped=true"
import script from "./CityDetail.vue?vue&type=script&lang=ts"
export * from "./CityDetail.vue?vue&type=script&lang=ts"
import style0 from "./CityDetail.vue?vue&type=style&index=0&id=2ac2b3ba&lang=scss"
import style1 from "./CityDetail.vue?vue&type=style&index=1&id=2ac2b3ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2b3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac2b3ba')) {
      api.createRecord('2ac2b3ba', component.options)
    } else {
      api.reload('2ac2b3ba', component.options)
    }
    module.hot.accept("./CityDetail.vue?vue&type=template&id=2ac2b3ba&scoped=true", function () {
      api.rerender('2ac2b3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/locations/cities/components/CityDetail.vue"
export default component.exports